export class PersonalBizumPaymentConfig {
    public allowPersonalBizumPayments?: boolean;
    public phoneNumber?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): PersonalBizumPaymentConfig {
        const personalBizumPaymentConfig: PersonalBizumPaymentConfig = new PersonalBizumPaymentConfig();

        personalBizumPaymentConfig.allowPersonalBizumPayments = this.allowPersonalBizumPayments;
        personalBizumPaymentConfig.phoneNumber = this.phoneNumber;

        return personalBizumPaymentConfig;
    }
}
